import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  warningBanner: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9998,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.warning.main,
    color: "#fff",
    fontSize: "14px",
    fontWeight: 500,
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    animation: "$slideDown 0.3s ease-out",
  },
  slowBanner: {
    backgroundColor: "#607D8B",
  },
  warningIcon: {
    fontSize: "20px",
  },
  warningText: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flexWrap: "wrap" as const,
  },
  bannerServiceDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    display: "inline-block",
    flexShrink: 0,
  },
  bannerServiceOk: {
    backgroundColor: "#A5D6A7",
  },
  bannerServiceFail: {
    backgroundColor: "#F44336",
    boxShadow: "0 0 4px rgba(244,67,54,0.6)",
  },
  bannerServiceItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    fontSize: 13,
    opacity: 0.95,
  },
  bannerSeparator: {
    width: 1,
    height: 14,
    backgroundColor: "rgba(255,255,255,0.4)",
  },
  dismissButton: {
    color: "#fff",
    marginLeft: theme.spacing(1),
    minWidth: "auto",
    padding: theme.spacing(0, 1),
    fontSize: "12px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.15)",
    },
  },

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    backdropFilter: "blur(4px)",
  },
  modalPaper: {
    width: 460,
    maxHeight: "90vh",
    overflowY: "auto" as const,
    padding: theme.spacing(3),
    borderRadius: 12,
    textAlign: "center",
    backgroundColor: "#fff",
    boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
  },
  offlineIcon: {
    fontSize: 48,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(1),
  },
  cookieIcon: {
    fontSize: 48,
    color: theme.palette.warning.main,
    marginBottom: theme.spacing(1),
  },
  serviceIcon: {
    fontSize: 48,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(1),
  },
  serviceList: {
    display: "flex",
    flexDirection: "column" as const,
    gap: 2,
    margin: theme.spacing(1.5, 0),
    padding: theme.spacing(1, 1.5),
    backgroundColor: theme.palette.grey[50],
    borderRadius: 8,
    textAlign: "left" as const,
  },
  serviceRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontSize: 12,
    lineHeight: 1.5,
  },
  serviceDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    flexShrink: 0,
  },
  serviceDotOk: {
    backgroundColor: "#4CAF50",
  },
  serviceDotFail: {
    backgroundColor: "#F44336",
  },
  supportText: {
    fontSize: 12,
    color: theme.palette.grey[500],
    marginTop: theme.spacing(1.5),
  },
  vpnHint: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1, 1.5),
    borderRadius: 8,
    backgroundColor: "#FFF8E1",
    border: "1px solid #FFE082",
    textAlign: "left" as const,
  },
  vpnHintTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.grey[800],
    marginBottom: 2,
  },
  vpnHintText: {
    fontSize: 11,
    color: theme.palette.grey[700],
    lineHeight: 1.4,
  },
  vpnToggle: {
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(0, 0.5),
    fontSize: 12,
    fontWeight: 600,
    textTransform: "none" as const,
    color: theme.palette.primary.main,
    minWidth: "auto",
  },
  vpnList: {
    display: "flex",
    flexDirection: "column" as const,
    gap: 4,
    marginTop: theme.spacing(1),
    padding: theme.spacing(1, 1.25),
    backgroundColor: "#fff",
    border: "1px solid #FFE082",
    borderRadius: 6,
  },
  vpnHost: {
    fontFamily:
      "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    fontSize: 12,
    color: theme.palette.grey[800],
    userSelect: "all" as const,
    wordBreak: "break-all" as const,
  },
  supportLink: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 4,
  },
  modalSubtitle: {
    fontSize: 13,
    color: theme.palette.grey[600],
    marginBottom: theme.spacing(2),
  },
  retryButton: {
    minWidth: 160,
    padding: theme.spacing(1, 3),
    fontSize: 13,
    fontWeight: 600,
  },
  checkingProgress: {
    marginRight: theme.spacing(1),
  },
  statusDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: theme.spacing(0.5),
    animation: "$pulse 1.5s infinite",
  },
  statusDotWarning: {
    backgroundColor: theme.palette.warning.main,
  },

  "@keyframes slideDown": {
    from: {
      transform: "translateY(-100%)",
      opacity: 0,
    },
    to: {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  "@keyframes pulse": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.4,
    },
  },
}));
